import { jsx, jsxs } from "react/jsx-runtime";
import { forwardRef, memo } from "react";
const SvgPackage = ({ title, titleId, ...props }, ref)=>/*#__PURE__*/ jsxs("svg", {
        viewBox: "0 0 24 25",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        focusable: "false",
        role: "img",
        ref: ref,
        "aria-labelledby": titleId,
        ...props,
        children: [
            title ? /*#__PURE__*/ jsx("title", {
                id: titleId,
                children: title
            }) : null,
            /*#__PURE__*/ jsx("path", {
                fill: "currentColor",
                d: "M1.005 19.176 1 19V9a3 3 0 0 1 2.824-2.995L4 6h1V2h-.5a.5.5 0 0 1-.09-.992L4.5 1h7a.5.5 0 0 1 .09.992L11.5 2H11v4h1a3 3 0 0 1 2.995 2.824L15 9V4h-.5a.5.5 0 0 1-.09-.992L14.5 3h6a.5.5 0 0 1 .09.992L20.5 4H20v6a3 3 0 0 1 2.995 2.824L23 13v6a3 3 0 0 1-2.824 2.995L20 22c0 .552-.336 1-.75 1s-.75-.448-.75-1h-2c0 .552-.336 1-.75 1s-.75-.448-.75-1c-.547 0-1.06-.146-1.5-.402-.379.22-.809.358-1.268.393L12 22c0 .566-.448 1.025-1 1.025s-1-.459-1-1.025H6a1 1 0 0 1-2 0 3 3 0 0 1-2.995-2.824M19 10V4h-3v6zm-9-8H6v4h4z"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "white",
                d: "M20 11a2 2 0 0 1 2 2v6l-.005.15A2 2 0 0 1 20 21h-5l-.174-.007a2 2 0 0 1-.493-.107A3 3 0 0 0 15 19v-8Zm-3 1.5a.5.5 0 0 0-.5.5v6l.008.09A.5.5 0 0 0 17.5 19v-6l-.008-.09A.5.5 0 0 0 17 12.5m2.5 0a.5.5 0 0 0-.5.5v6l.008.09A.5.5 0 0 0 20 19v-6l-.008-.09a.5.5 0 0 0-.492-.41"
            }),
            /*#__PURE__*/ jsx("path", {
                fill: "#E8F2FF",
                d: "M12 7a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2zM4.5 9a.5.5 0 0 0-.492.41L4 9.5V19l.008.09a.5.5 0 0 0 .984 0L5 19V9.5l-.008-.09A.5.5 0 0 0 4.5 9M8 9a.5.5 0 0 0-.492.41L7.5 9.5V19l.008.09a.5.5 0 0 0 .984 0L8.5 19V9.5l-.008-.09A.5.5 0 0 0 8 9m3.5 0a.5.5 0 0 0-.492.41L11 9.5V19l.008.09a.5.5 0 0 0 .984 0L12 19V9.5l-.008-.09A.5.5 0 0 0 11.5 9"
            })
        ]
    });
const ForwardRef = /*#__PURE__*/ forwardRef(SvgPackage);
const Memo = /*#__PURE__*/ memo(ForwardRef);
const Package = Memo;
export { Package as default };
